import React from 'react';

export function PageHeader({ title, description, actions, filters, className = '' }) {
  return (
    <div className={`bg-prodia-surface border-b border-prodia-border flex-shrink-0 ${className}`}>
      <div className="px-4 sm:px-6 py-4">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <div className="min-w-0">
            <h1 className="text-xl font-semibold text-prodia-text-primary truncate">{title}</h1>
            {description && (
              <p className="text-sm text-prodia-text-secondary mt-0.5">{description}</p>
            )}
          </div>
          {actions && (
            <div className="flex flex-wrap items-center gap-2 flex-shrink-0">{actions}</div>
          )}
        </div>
        {filters && (
          <div className="mt-4 pt-4 border-t border-prodia-border">{filters}</div>
        )}
      </div>
    </div>
  );
}

export default PageHeader;
